

















import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class UploadMediaTriggerArea extends Vue {
  @Prop({ default: 'large' }) type!: 'small' | 'large'

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  @Emit('onAreaClick')
  onAreaClick(): boolean {
    return true
  }

  get areaTypeClass(): string {
    if (this.type === 'small') {
      return 'upload-media-trigger-area_small'
    }
    return 'upload-media-trigger-area'
  }

  get iconType(): string {
    return this.type === 'large' ? 'touch_app' : 'add'
  }

  get areaDescription(): string {
    return this.type === 'large' ? this.$t('upload_media_description_large').toString() : this.$t('upload_media_description_small').toString()
  }

  // created(): void {
  //   this.$i18n.mergeLocaleMessage('ru', {
  //     upload_media_description_small: 'Загрузка медиа',
  //     upload_media_description_large: 'Нажмите, чтобы загрузить медиа',
  //   })
  //   this.$i18n.mergeLocaleMessage('en', {
  //     upload_media_description_small: 'Upload media',
  //     upload_media_description_large: 'Click to start uploading media',
  //   })
  // }
}
